let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7Jxxc")).then(() => parcelRequire('j2Q7A'));